import AmountCell from '@UI/Pages/Administration/AiCosts/CostTabs/Shared/AmountCell';
import resolveDeviationChip from '@UI/Pages/Administration/AiCosts/CostTabs/SubjectCosts/Helpers/resolveDeviationChip';
import formatEuros from '@UI/Helpers/formatEuros';
import formatCount from '@UI/Pages/Administration/AiCosts/Helpers/formatCount';
import type AiCostAudioView from '@UI/Store/AiCosts/Views/AiCostAudioView';
import type AiCostDocumentsView from '@UI/Store/AiCosts/Views/AiCostDocumentsView';
import type * as React from 'react';

type Props = {
	readonly part: AiCostAudioView | AiCostDocumentsView;
	/** What one item of this part is called in "x € / audio". */
	readonly unit: 'audio' | 'document';
	readonly referenceAverage: number | null;
	/** Ink of the amount. */
	readonly color: string;
};

/** The cost of the audio or document part of a row: amount, average per item, then the unpriced count or the deviation. */
const PartCostCell: React.FC<Props> = ({ part, unit, referenceAverage, color }) => {
	const average = part.averageCost;
	const unpricedChip = part.unpricedCount > 0 ? `dont ${formatCount(part.unpricedCount)} sans tarif` : null;

	return (
		<AmountCell
			label={
				part.count > 0 && part.count === part.unpricedCount
					? 'Sans tarif'
					: formatEuros(part.costAmount)
			}
			detail={average === null ? null : `${formatEuros(average)} / ${unit}`}
			chip={unpricedChip ?? resolveDeviationChip(average, referenceAverage, part.count)}
			chipTone={unpricedChip === null ? 'danger' : 'warning'}
			color={color}
		/>
	);
};

export default PartCostCell;
